import { memo, useMemo } from 'react'
import { Table, Space, Popconfirm } from 'antd'
import type { ColumnsType } from 'antd/es/table'
import { TrainingGamePlayer } from 'types/game-player'
import { tableValueFromBoolean } from '../../utils'
import { modalTitle as formatModalTitle } from 'utils/modal-title'
import dayjs from 'dayjs'

type Props = {
    data: TrainingGamePlayer[]
    // onEdit: (id: number) => void
    onDelete: (telegramId: number, gameID: number) => void
    onMoveToMain: (telegramId: number, gameID: number) => void
    onMoveToReserve: (telegramId: number, gameID: number) => void
    loading: boolean
}

export const TrainingGamesPlayersTable = memo((props: Props) => {
    const { data, onDelete, loading, onMoveToMain, onMoveToReserve } = props

    const columns: ColumnsType<TrainingGamePlayer> = useMemo(
        () => [
            {
                title: 'Index',
                key: 'index',
                render: (_, record, index) => `${index + 1}`,
            },
            {
                title: 'telegramId',
                dataIndex: 'telegramId',
                key: 'telegramId',
            },
            {
                title: 'gameId',
                dataIndex: 'gameId',
                key: 'gameId',
            },
            {
                title: 'reserve',
                key: 'reserve',
                render: (_, record) => tableValueFromBoolean(record.reserve),
            },
            {
                title: 'createdAt',
                key: 'createdAt',
                render: (_, record) => dayjs(record.createdAt).format('DD.MM.YYYY HH:mm:ss'),
            },
            {
                title: 'Action',
                key: 'action',
                render: (_, record) => {
                    const playerInReserve = !!record.reserve
                    const changeStatusDescription = playerInReserve ? `Move to the main squad?` : `Move to reserve?`
                    const changeStatusActionName = playerInReserve ? 'To main' : 'To reserve'
                    const changeStatusAction = playerInReserve ? onMoveToMain : onMoveToReserve

                    return (
                        <Space size='middle'>
                            <Popconfirm
                                title={formatModalTitle(
                                    'Remove player',
                                    `telegram ${record.telegramId} (game #${record.gameId})`
                                )}
                                description={'Are you sure to remove this player from game?'}
                                onConfirm={() => onDelete(record.telegramId, record.gameId)}
                                okText={'Yes'}
                                cancelText={'No'}
                            >
                                <a href='#'>Delete</a>
                            </Popconfirm>
                            <Popconfirm
                                title={formatModalTitle(
                                    'Change status',
                                    `telegram ${record.telegramId} (game #${record.gameId})`
                                )}
                                description={changeStatusDescription}
                                onConfirm={() => changeStatusAction(record.telegramId, record.gameId)}
                                okText={'Yes'}
                                cancelText={'No'}
                            >
                                <a href='#'>{changeStatusActionName}</a>
                            </Popconfirm>
                        </Space>
                    )
                },
            },
        ],
        [onDelete, onMoveToMain, onMoveToReserve]
    )

    return <Table loading={loading} columns={columns} dataSource={data} rowKey='telegramId' pagination={false} />
})
